export enum FieldMasks {
  Phone = 1,
  SSN = 2,
}
